<template>
  <div class="nav">
    <nav>
      <a href="/" class="logo-img">
        <img :src="pelexLogo" loading="lazy" height="50" alt="Pelex Logo">
        </a>
    </nav>
  </div>
</template>

<script>
import Logo from "../assets/pelex-logo.svg"

export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data () {
    return {
      pelexLogo: Logo
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nav {
  position: sticky;
  top: 0;
  z-index: 9;
  padding: 20px;
  background-color: #fff;
}
nav {
  position: relative;
  z-index: 10;
  width: 100%;
  max-width: 1240px;
  margin-right: auto;
  margin-left: auto;
  padding-right: 20px;
  padding-left: 20px;
}
.logo-img {
  max-width: 180px;
  display: inline-block;
}
</style>
